import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="inline-edit"
export default class extends Controller {
  static targets = ["display", "input", "form", "saveButton", "spinner"]
  static values = {
    url: String,
    field: String
  }

  connect() {
    // console.log("Inline edit controller connected", this.fieldValue)
  }

  edit() {
    // Hide display, show input
    this.displayTarget.classList.add("hidden")
    this.inputTarget.classList.remove("hidden")

    // Focus the input field
    const input = this.inputTarget.querySelector("input, textarea")
    if (input) {
      input.focus()
      input.select()
    }
  }

  cancel(event) {
    // If Escape key pressed or cancel button clicked
    if (event) {
      event.preventDefault()
    }
    this.hideInput()
  }

  save(event) {
    // Prevent default if it's an event
    if (event && event.preventDefault) {
      event.preventDefault()
    }

    // Get the input value
    const input = this.inputTarget.querySelector("input, textarea")
    if (!input) return

    // Show spinner, hide save button
    if (this.hasSaveButtonTarget && this.hasSpinnerTarget) {
      this.saveButtonTarget.classList.add("hidden")
      this.spinnerTarget.classList.remove("hidden")
    }

    // Submit the form using Turbo
    const form = this.formTarget
    if (form) {
      form.requestSubmit()
    }
  }

  handleKeydown(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault()
      this.save()
    } else if (event.key === "Escape") {
      event.preventDefault()
      this.cancel(event)
    }
  }

  hideInput() {
    // Show display, hide input
    this.displayTarget.classList.remove("hidden")
    this.inputTarget.classList.add("hidden")

    // Reset button states
    if (this.hasSaveButtonTarget && this.hasSpinnerTarget) {
      this.saveButtonTarget.classList.remove("hidden")
      this.spinnerTarget.classList.add("hidden")
    }
  }

  // Called after successful turbo stream update
  handleSuccess() {
    this.hideInput()
  }
}
